module.exports = __webpack_public_path__ + "img/logo.779d9625.svg";